module.exports = __webpack_public_path__ + "static/media/sidebar-full-bg.7d9225a2.jpg";